module.exports = __webpack_public_path__ + "static/media/icon-risk-management.8252eda5.svg";